module.exports = __webpack_public_path__ + "static/media/mc_id.d7c4ea0d.png";